import { range } from "lodash"
import { Scale } from "../../../utils/Scale"
import { Sprites } from "../../../utils/Sprites"
import { MakeAVideoStore } from "../MakeAVideoStore"
import { MakeVideoImages } from "../MakeVideoAssets"
import { MakeVideoSprite } from "../MakeVideoTypes"

export class MakeVideoVideoTimeline implements MakeVideoSprite {

    active: boolean
    tiles: Array<MakeVideoTimelineTile>
    private timelineFrame: Phaser.Sprite

    constructor(game: Phaser.Game, group: Phaser.Group, x: number, y: number, debug: boolean) {
        this.timelineFrame = Sprites.add(game, MakeVideoImages.VIDEO_TIMELINE, {scale: 0.9, debug, group, x, y})

        const tileNumbers: Array<number> = range(1, 9)
        const initTileY = y + Scale.y(0.00225)
        let initTileX = this.timelineFrame.x + Scale.x(0.0475)
        this.tiles = tileNumbers.map(n => {
            const tile = new MakeVideoTimelineTile(game, n, group, initTileX, initTileY, debug)
            initTileX += tile.sprite.width + Scale.x(0.00125)
            return tile
        })
        this.active = true
    }

    destroy = () => {
        this.timelineFrame.destroy(true)
        this.tiles.forEach(tile => tile.destroy())
        this.active = false
    }
}

export class MakeVideoTimelineTile implements MakeVideoSprite {
    active: boolean
    sprite: Phaser.Sprite
    private current: string

    private static videoTileName = (t: number): string => {
        if (t >= 1 && t <= 8) {
            return `video-tile-${t}.png`
        }
    }

    constructor(
        private game: Phaser.Game,
        public tile: number,
        group: Phaser.Group,
        x: number,
        y: number,
        debug: boolean
    ) {
        this.sprite = Sprites.add(game, MakeVideoTimelineTile.videoTileName(tile), {scale: 0.88, debug, group, x, y})
        this.game.physics.arcade.enable(this.sprite)
        this.active = true
        this.current = ""
    }

    get filled(): boolean {
        return this.current !== ""
    }

    get clip(): string {
        return this.current
    }

    addClip = (clip: string) => {
        this.current = clip
        MakeAVideoStore.instance.video = {index: this.tile - 1, clip}
    }

    removeClip = () => {
        this.current = ""
        MakeAVideoStore.instance.video = {index: this.tile - 1, clip: this.current}
    }

    destroy = () => {
        this.sprite.destroy(true)
        this.current = ""
        this.active = false
    }
}
